import { render, staticRenderFns } from "./MenuEmanifiestoMV.vue?vue&type=template&id=9ea4573e&scoped=true&"
import script from "./MenuEmanifiestoMV.vue?vue&type=script&lang=js&"
export * from "./MenuEmanifiestoMV.vue?vue&type=script&lang=js&"
import style0 from "./MenuEmanifiestoMV.vue?vue&type=style&index=0&id=9ea4573e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea4573e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDivider,VIcon,VList,VMenu,VSpacer})
